import { Directive, ElementRef, HostListener, Input, Optional } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[numericRange]'
})
export class NumericRangeDirective {
  constructor(private el: ElementRef) { }

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    const inputValue = inputElement.value;

    const newValue = inputValue.replace(/[^0-9]/g, '');

    if (newValue !== inputValue) {
      inputElement.value = newValue;
    }
  }

  
}

@Directive({
  selector: '[decimalFormat]'
})
export class FormatDecimalDirective {
  // se não passar valor, usa 2 casas decimais
  @Input('decimalFormat') decimalPlaces?: any = null;

  constructor(private el: ElementRef, @Optional() private ngModel: NgModel) { }

  ngOnInit() {
    if (this.ngModel) {
      this.format();
      this.ngModel.valueChanges?.subscribe(() => this.format());
    } else {
      this.format();
    }
  }

  @HostListener('blur')
  onBlur() {
    this.format();
  }

  private format() {
    if (!this.decimalPlaces)
        this.decimalPlaces = 2;
    
    const input = this.el.nativeElement as HTMLInputElement;
    const value = parseFloat(input.value);
    const places = this.decimalPlaces ?? 2; // padrão 2 casas

    if (!isNaN(value)) {
      input.value = value.toFixed(places);
    }
  }
}
